import NextLink, {
  type LinkProps,
} from "@casino/legacy/client/shared/NextLink";
import { cn } from "@workspace/frontend-ui";

type Props = {
  $controlsOnTopRight?: boolean;
  $isMobile?: boolean;
} & LinkProps;

const SeeAllLink: FC<Props> = ({
  children,
  $controlsOnTopRight,
  $isMobile,
  ...props
}) => (
  <NextLink
    {...props}
    className={cn(
      "flex min-h-[1.5rem] items-center text-foreground underline [&_p]:text-sm/6",
      $controlsOnTopRight && "mr-24",
      $controlsOnTopRight && $isMobile && "hidden",
    )}
  >
    {children}
  </NextLink>
);

export default SeeAllLink;
